import {
  DeleteOutlined as DeleteIcon,
  EditNoteOutlined as EditNoteIcon,
  NoteAddOutlined as NoteAddIcon,
} from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';

export interface AssetItemActionsProps {
  id: string;
  quantity: number;
  note: string;
  hasDetails?: boolean;
  onQuantityChange: (id: string, delta: number) => void;
  onNoteClick: (id: string, note: string) => void;
  onDelete: (id: string) => void;
}

export const AssetItemActions: React.FC<AssetItemActionsProps> = ({ id, quantity, note, hasDetails, onQuantityChange, onNoteClick, onDelete }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
    <IconButton size="small" onClick={() => onQuantityChange(id, -1)} disabled={quantity <= 1} sx={{ borderRadius: 1, width: 24, height: 24 }}>
      <Typography variant="body2" sx={{ lineHeight: 1, fontWeight: 500 }}>−</Typography>
    </IconButton>
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, minWidth: 32, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', px: 0.5 }}>
      <Typography variant="body2">{quantity}</Typography>
    </Box>
    <IconButton size="small" onClick={() => onQuantityChange(id, 1)} sx={{ borderRadius: 1, width: 24, height: 24 }}>
      <Typography variant="body2" sx={{ lineHeight: 1, fontWeight: 500 }}>+</Typography>
    </IconButton>
    <IconButton size="small" onClick={() => onNoteClick(id, note)}>
      {(hasDetails ?? !!note) ? <EditNoteIcon fontSize="small" /> : <NoteAddIcon fontSize="small" />}
    </IconButton>
    <IconButton size="small" onClick={() => onDelete(id)}>
      <DeleteIcon fontSize="small" />
    </IconButton>
  </Box>
);
